import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getIconForTransfer } from './../../utils';



import { Field, Label } from '../../catalyst/fieldset';
import { Listbox, ListboxLabel, ListboxOption } from '../../catalyst/listbox';


export default function AccountsDetails(props) {


    const [hasEnoughAccounts, setHasEnoughAccounts] = useState(props.connectedAccounts==null?false:props.connectedAccounts.length>0);

    const [connectedAccounts, setConnectedAccounts] = useState(props.connectedAccounts)

    const navigate = useNavigate();





    const handleCurrentAccountSelectionChange = (id) => {
        props.onSelectedAccountChange(id);
      };
    
    
    function AccountSelector() {
        return (
            <>

        <Field>
            <Label>{props.defaultSelectText}</Label>
                <Listbox className="cursor-pointer" placeholder="Select music account"
                        onChange={(id) => handleCurrentAccountSelectionChange(id)}
                        value={props.selectedAccount ==="" || props.selectedAccoun=== null ? undefined : props.selectedAccount}
  
                    >
                        {/* <MenuItem value="">
                             {getIconForTransfer("appleMusic")}  <span>&nbsp;Apple Music</span>
                        </MenuItem> */}

                        {
                            props.connectedAccounts.map((account) => {
                                if(account.accountType === "spotify") {
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType, false)} &nbsp; <ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }
{/* 
                        <MenuItem value="">
                            <em>Spotify</em>
                        </MenuItem> */}
                        {
                            props.connectedAccounts.map((account) => {
                                if(account.accountType === "appleMusic") {
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType, false)}&nbsp;<ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }
                                                
                        {
                            props.connectedAccounts.map((account) => {
                                if(account.accountType === "youtube") {
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType, account.isYoutubeMusic)}&nbsp;<ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }
                                                
                        {
                            props.connectedAccounts.map((account) => {
                                if(account.accountType === "tidal") {
                                    return (<ListboxOption vclassName="cursor-pointer" alue={account.id} key={account.id}>{getIconForTransfer(account.accountType, account.isYoutubeMusic)}&nbsp;<ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }
                    </Listbox>
                </Field>




            </>
        );
    }



    return (
        
        <>
            { hasEnoughAccounts ?
                    (<AccountSelector></AccountSelector>)
                    : (<></>)
            }
        </>
    )
}